// @flow

import * as React from 'react';
import { Flex } from 'react-system';
import { type BucketImage } from '@realadvisor/cloudinary';
import { Image, type ImageSize } from '@realadvisor/image';

/*
type AllowedBackgroundPositions =
  | 'top center'
  | 'center center'
  | 'bottom center'
  | 'bottom left';
*/
// type BackgroundSizes = 'contain' | 'cover';

type Props = {|
  file: null | string | BucketImage,
  children: React.Node,
  objectPosition?: ?string,
  imageSize?: ImageSize,
  className?: string,
  css?: any,
  preview?: boolean,
  backgroundColor?: string,
|};

export const Hero = (props: Props): React.Node => {
  // const imageWidths = props.imageWidths ?? [980, 1440, 2400];
  // const imageRatios = props.imageRatios ?? [0.54, 0.54, 0.54];
  const defaultRatio = 0.54;
  const imageSize = props.imageSize ?? [
    [384, 384],
    [1024, 1024 * defaultRatio],
    [1536, 1536 * defaultRatio],
  ];

  // const backgroundPosition = props.backgroundPosition ?? 'bottom center';
  // const backgroundSize = props.backgroundSize ?? 'cover';

  return (
    <Flex
      justifyContent="center"
      alignItems="center"
      className={props.className ?? ''}
      css={[
        {
          // to allow spread overlay with gradient
          position: 'relative',
          minHeight: '568px',
        },
      ]}
    >
      <div
        css={{
          position: 'absolute',
          left: 0,
          top: 0,
          bottom: 0,
          right: 0,
          zIndex: -1,
        }}
      >
        {props.file != null && (
          <Image
            src={props.file}
            srcSize={imageSize}
            objectPosition={props.objectPosition}
            backgroundColor={props.backgroundColor}
          />
        )}
      </div>
      {props.children}
    </Flex>
  );
};
